export default __webpack_public_path__ + "static/media/HighTrending.eccb4293.svg";